<template>
    <div itemscope itemtype="https://schema.org/Recipe">
        <div class="box relative panelback single-recipe flex p-4 m-2 mt-0 py-10">
            <div class="absolute top-0 left-0 w-full pb-4 pl-3">
                <h2 class="mt-1 pl-1 text-secondary-light text-xl" itemprop="name">{{ recipe.name }}</h2>
                <meta itemprop="datePublished" :content="recipe.updated_at">
            </div>
            <div class="w-full md:w-1/4">
                <img class="recipe-image border border-black" :src="`/api/get-recipe-image/${recipe.img ?? 'no-image.jpg'}`" alt="recipe.name" itemprop="image" />
            </div>
            <div class="w-3/4 pl-4 text-lg flex flex-col justify-start text-slate-400">
                <div class="flex flex-wrap justify-between ">
                    <h3 class="w-full px-2 italic text-slate-500 -mb-2">{{ recipe.food_type }}</h3>
                    <div v-if="recipe && recipe.description" v-html="recipe.description"
                        class="text-slate-200 mb-4 p-2" itemprop="description"></div>
                    <div v-else itemprop="no description">No description. </div>
                    <ul class="m-2">
                        <li class="pill" v-for="tag in origins" :key="tag.id" itemprop="keywords">{{ tag.name }}</li>
                    </ul>
                </div>
                <div v-if="recipe.link" class="link text-blue-200 mb-4 p-2"><a :href="recipe.link" class="bg-slate-900 hover:bg-blue-900 px-8 py-2">LINK</a>
                </div>
                <div v-if="recipe['tags'] && recipe['tags'].length > 0" class=" p-2 rounded-md">
                    <h3 class="text-xl text-yellow-200 mb-2">Ingredients & Tags:</h3>
                    <ul class="no-bullet flex flex-wrap gap-2  p-0 m-0">
                        <li v-for="tag, index in ingredients" class="pill" :key="index" itemprop="recipeIngredient">
                            {{ tag.pivot['amount'] }} {{ tag.name }}
                        </li>
                    </ul>
                </div>
                <div v-if="recipe['directions']" class="mt-4 p-2 directions ">
                    <h3 class="text-xl text-gray-600">Directions</h3>
                    <div class="text-sm" v-html="recipe.directions" itemprop="recipeInstructions"></div>
                </div>
                <div v-if="recipe.ingredients" class="mt-4 p-2 directions ">
                    <h3 class="text-xl text-gray-600">ingredients</h3>
                    <div class="text-sm" v-html="recipe.ingredients" itemprop="recipeInstructions"></div>
                </div>
                <div class="justify-end text-xxs text-right p-2">{{ formatDate(recipe.updated_at, 'MMM D, YYYY') }} {{ recipe.id }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import dayjs from 'dayjs'
    import { mapState, mapWritableState } from 'pinia'
    import { useGeneralStore } from '@/utils/useGeneralStore.js'
    import * as DataService from "../DataService.js";
    import { gsap } from "gsap/all";

    export default {
        name: 'RecipeCard',
        props: ['recipe'],
        // watch: {
        //     slug(n) {
        //         if(n) {
        //             this.recipe=this.recipes?.find(r => r.slug == n);
        //         }
        //     }
        // },
        computed: {
            ...mapState(useGeneralStore, ['bbSectionHeader', 'headerClass', 'recipes']),
            origins() {
                if (!this.recipe) return;
                return this.recipe['tags']?.filter(t => t.type == 'origin');
            },
            ingredients() {
                if (!this.recipe) return;
                return this.recipe['tags'].filter(t => t.type == 'ingredient');
            },
        },
        data() {
            return {
                // recipe: null
            }
        },
        mounted() {
            // this.loadRecipe();
        },
        methods: {
            formatDate(t, format = 'YYYY') {
                return dayjs(t).format(format);
            },
        }
    }
</script>
<style scoped>
.pill {
    border-radius: 12px;
    background-color: var(--primary-light);
    border: 1px solid var(--primary-dark);
    color: var(--secondary-light);
}
</style>
